<section class="flex flex-col gap-8">
  @if (!loading()) {
    @if (openPosition(); as position) {
      <app-compound-card
        [title]="position.title"
        [description]="position.description"
        sectionClassName="bg-gray-100 gap-4"
        titleClassName="text-4xl"
        descriptionClassName="text-xl"
        [headerBadges]="position.headerBadges"
        [footerBadges]="position.footerBadges"/>

      <div class="flex flex-col gap-8 border-b border-gray-200 pb-8 lg:flex-row">
        <div class="h-fit w-full lg:w-1/2">
          <app-form-card
            title="Apply For This Job Opening"
            subtitle="To apply, please fill out the form below with accurate, up-to-date information."
            [formGroup]="contactForm"
            [fields]="fields"
            (formSubmit)="onSubmit()"/>
        </div>

        <div class="flex w-full flex-col gap-4 lg:w-1/2">
          @for (details of position.benefits; track details) {
            <app-info-card
              [title]="details.title"
              [description]="details.description"
              sectionClassName="bg-gray-100 gap-4 p-8"
              titleClassName="text-2xl"
              descriptionClassName="text-base"/>
          }

          @if (position.hardSkills.length > 0) {
            <app-info-card
              [title]="'We Need you to have some hard skills'"
              [listItems]="position.hardSkills"
              [showListItemIcon]="true"
              sectionClassName="bg-gray-100 gap-4 p-8"
              titleClassName="text-2xl"
              listItemsClassName="text-sm text-foreground text-start"/>
          }

          @if (position.softSkills.length > 0) {
            <app-info-card
              [title]="'We Need you to have some soft skills'"
              [listItems]="position.softSkills"
              [showListItemIcon]="true"
              sectionClassName="bg-gray-100 gap-4 p-8"
              titleClassName="text-2xl"
              listItemsClassName="text-sm text-foreground text-start"/>
          }

          <div class="flex flex-col">
            <div class="flex h-full flex-col items-center gap-2.5 rounded-3xl bg-gray-100 p-8 lg:items-start">
              <span class="text-2xl">{{ teamDetailsData.title }}</span>
            </div>
            <div class="flex h-full flex-col items-center gap-2.5 rounded-3xl bg-gray-100 p-8 lg:items-start">
              <div class="grid w-full grid-cols-2 gap-6">
                @for (item of teamDetailsData.details; track item) {
                  <div class="flex flex-col gap-3">
                    <div class="relative h-8 w-8 rounded-[50%] bg-primary">
                      <span
                        [inlineSVG]="item.icon"
                        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-foreground"></span>
                    </div>
                    <span class="text-lg">{{ item.title }}</span>
                    <span class="text-base text-secondary-foreground">{{ item.description }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="flex w-full items-center justify-center rounded-2xl border-gray-200 bg-gray-50">
      <img ngSrc="assets/media/images/careers-img2.svg" width="780" height="520" priority alt="careers"
           class="max-h-[520px] w-full"/>
    </div>
  } @else {
    <hlm-skeleton class="h-[200px] w-full"/>
    <div class="flex flex-col gap-8 border-b border-gray-200 pb-8 lg:flex-row">
      <div class="h-fit w-full lg:w-1/2">
        <hlm-skeleton class="h-[600px] w-full"/>
      </div>
      <div class="flex w-full flex-col gap-4 lg:w-1/2">
        @for (mock of [1, 2, 3, 4]; track mock) {
          <hlm-skeleton class="h-[300px] w-full"/>
        }
      </div>
    </div>
  }
</section>
